<template>
    <div>
        <section class="ai-page-3">

            <div class="ai-page-3-container">
                <div class="ai-page-3-left">
                    <button type="button" class="ai-btn-prev" @click="changeStep(1)">
                        <img :src="`${m_cloud_url()}uteach/assets/ai-left-chevron 1.svg`" alt="Go to first step" width="22" height="22">
                        <span>Go to first step</span>
                    </button>
                    <div v-for="(name, index) in namesResponseData" class="ai-page-2-item">
                        <p>{{name}}</p>

                        <button v-if="index !== currentTitle.index" type="button" class="ai-gen-btn" @click="generateDescription({name: name, index: index});  copiedDescriptionIndex = null">
                            <img :src="`${m_cloud_url()}uteach/assets/ai-generate-distribution.svg`" alt="Generate" width="15" height="16">
                            <span>Generate description</span>
                        </button>
                        <button type="button" aria-label="Copy" class="ai-btn-copy" title="Copy" @click="copyToClipboard(name, index, true)">
                            <img v-if="copiedNameIndex !== index" :src="`${m_cloud_url()}uteach/assets/ai-copy.svg`" alt="Copy" width="14" height="16">
                            <img v-else :src="`${m_cloud_url()}uteach/assets/ai-checkmark.svg`" alt="Copy" width="12" height="12">
                        </button>
                    </div>
                </div>

                <div v-if="descriptionsResponseData" class="ai-page-3-right">
                    <h1>Generated descriptions</h1>

                    <div v-for="(description, index) in descriptionsResponseData" class="ai-page-3-item">
                        <span v-if="index === 0" class="ai-page-3-edu">{{currentTitle.name}}</span>
                        <button type="button" aria-label="remove" class="gen-remove-btn" title="Remove" @click="removeDescription(index)">
                            <img :src="`${m_cloud_url()}uteach/assets/ai-close.svg`" alt="Remove" width="12" height="12">
                        </button>
                        <p>{{description}}</p>
                        <div class="ai-page-3-item-bottom">
                            <button type="button" aria-label="Copy" class="ai-btn-copy" title="Copy" @click="copyToClipboard(description, index, false)">
                                <img v-if="copiedDescriptionIndex !== index" :src="`${m_cloud_url()}uteach/assets/ai-copy.svg`" alt="Copy" width="14" height="16">
                                <img v-else :src="`${m_cloud_url()}uteach/assets/ai-checkmark.svg`" alt="Copy" width="12" height="12">
                            </button>
                            <form @submit="" class="create-outline-form">
                                <input type="hidden" class="title" :value="currentTitle?.name">
                                <input type="hidden" class="description" :value="description">
                                <button type="submit" class="btn-gradient" id="create-outline-btn">
                                    <span>Create outline</span>
                                </button>
                            </form>
                        </div>
                    </div>
                    <div class="ai-page-3-regenerate">
                        <button type="button" class="ai-gen-btn" @click="generateDescription({name: currentTitle.name, index: currentTitle.index}); copiedDescriptionIndex = null">
                            <img :src="`${m_cloud_url()}uteach/assets/ai-generate-distribution.svg`" alt="Generate" width="15" height="16">
                            <span>Regenerate description</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
    components: {},

    data() {
        return {
            copiedNameIndex: null,
            copiedDescriptionIndex: null,
        };
    },

    computed: {
        ...mapGetters(["descriptionsResponseData", "namesResponseData", "currentTitle"])
    },
    methods: {
        ...mapActions(["updateDescriptions", "generateDescription", "changeStep"]),

        removeDescription(index) {
            let updatedDescriptions = [...this.descriptionsResponseData];
            updatedDescriptions.splice(index, 1);

            this.updateDescriptions(updatedDescriptions);
        },

        async copyToClipboard(text, index, isTitle) {
            try {
                await navigator.clipboard.writeText(text);

                if(isTitle) {
                    this.copiedNameIndex = index;
                    this.copiedDescriptionIndex = null;
                } else {
                    this.copiedNameIndex = null;
                    this.copiedDescriptionIndex = index;
                }
            } catch (err) {

            }
        },
    },
    watch: {
        descriptionsResponseData: {
            handler(newVal) {

            },
            deep: true,
            immediate: true
        }
    }

};
</script>
